/* eslint-disable import/prefer-default-export */
import { useState } from 'react'
import { useQueryClient, useMutation } from 'react-query'
import { useRouter } from 'next/router'
import { createReview } from 'services/reviews'
import { createCourseEnrolmentService } from 'services/course'
import { useInfiniteCourseReviews } from 'querys/reviews'
import { useCourseKey } from 'querys/course'
import useSession from 'querys/session'

export function useCreateReview() {
  const router = useRouter()
  const { query: { course } } = router
  const reviewsQuery = useInfiniteCourseReviews()
  const courseKey = useCourseKey()
  const { token } = useSession()
  const queryClient = useQueryClient()
  return useMutation(
    (review) => createReview({ course, token, ...review }),
    {
      // Update Courses Query With the data in reveviews and user_reviews
      onSuccess: (userReview) => {
        reviewsQuery.remove()
        queryClient.setQueryData(courseKey, (courseData) => ({ ...courseData, user_review: userReview }))
        queryClient.setQueryData(['REVIEWS', course], (courseData) => [userReview, ...courseData])
      },
    },
  )
}

export function useCreateCourseEnrolment(course, onSuccess) {
  const [success, setSuccess] = useState(false)
  const { token } = useSession()
  const queryClient = useQueryClient()
  const courseKey = useCourseKey()
  const mutation = useMutation(
    () => createCourseEnrolmentService({ course, token }),
    {
      onSuccess: (freeCourse) => {
        setSuccess(true)
        queryClient.setQueryData(courseKey, (courseData) => ({ ...courseData, has_access: true }))
        queryClient.setQueryData(['GET_PAYMET_STATUS', course, token], (status) => ({ ...status, has_access: true }))
        onSuccess()
      },
    },
  )
  return {
    ...mutation, success,
  }
}
